const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StorePickupPackageCommand: any = {
    SubmitStorePickupPackageList: Backofficebff + '/v1/store/approve-store-pickup-shipment',
    PrintReport: Backofficebff + '/v1/store/print-dfs-documents',
    GetReportHistory: Backofficebff + '/v1/store/get-dfs-documents',
    GenerateStorePickupMessage: Backofficebff + '/v1/store/generate-store-pickup-message',
    MarkDPackageShipmentMissing: Backofficebff + '/v1/store/mark-d-package-shipment-missing',
};
